// extracted by mini-css-extract-plugin
export default {"cover_img":"WorkTmpl_cover_img__wkY06"};